import type { ReactNode } from "react";
import { useIntercom } from "../hooks/useIntercom";
import type { IntercomUser } from "../types/intercom";

interface IntercomProviderProps {
	children: ReactNode;
	user: IntercomUser | null;
	enabled?: boolean;
	appId?: string;
}

export function IntercomProvider({
	children,
	user,
	enabled = true,
	appId,
}: IntercomProviderProps) {
	useIntercom({ user, enabled, appId });

	return <>{children}</>;
}
